import React from 'react';
import './Processing.css';

export default function Processing(): JSX.Element {
    return (
        <section className="elementor-section elementor-inner-section elementor-element elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="17d24cf" data-element_type="section" id="processing">
            <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-row">
                    <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-bb5ca74" data-id="bb5ca74" data-element_type="column">
                        <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                                <div className="elementor-element elementor-widget elementor-widget-heading" data-id="5a8c6a7" data-element_type="widget" data-widget_type="heading.default">
                                    <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default color-accent text-center">Processing...</h2>		</div>
                                </div>
                                <div className="elementor-element fa-spin elementor-view-default elementor-widget elementor-widget-icon" data-id="0aa5944" data-element_type="widget" data-widget_type="icon.default">
                                    <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper text-center">
                                            <div className="elementor-icon">
                                                <i aria-hidden="true" className="fas fa-spinner"></i>			</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}